export const liquidGoldEligible=user=>Boolean(user && typeof user==='object' && (user.id || user.email));
// This is presentation eligibility only; server authentication/permissions stay unchanged.
export const liquidGoldAllowed=(user,granted)=>liquidGoldEligible(user)||(user===false&&granted===true);

// The accepted Chancen interface is the production default for every role.
// Liquid Gold remains an explicit comparison only; it grants no permissions.
export const liquidGoldRequest=search=>{
 const value=new URLSearchParams(search).get('mobile_design');
 return value==='liquid-preview'?'1':value==='chances'?'0':null;
};
export const liquidGoldEnabled=({user,narrow,requested,saved,granted})=>
 Boolean(narrow&&liquidGoldAllowed(user,granted)&&requested!=='0'&&(requested==='1'||saved===true));
